import { BasicAuthServiceHelper } from '@/modules/Auth'
import APIRoutes from './APIRoutes'

import { ConversationsData, Conversation, RequestCartsData } from '@/data/PetSitter/Messages'

export async function getConversationAsync(IRI: string, page = 1): Promise<Conversation> {
  const { method } = APIRoutes.GetConversation()

  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(`${IRI}?page=${page}`, method)
  return response as Conversation
}

export async function getConversationsAsync(page = 1): Promise<ConversationsData> {
  const { path: urlPath, method } = APIRoutes.GetConversations

  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(`${urlPath}?page=${page}`, method)
  return response as ConversationsData
}

export async function getRequestCartsAsync(): Promise<RequestCartsData> {
  const { path: urlPath, method } = APIRoutes.GetRequestCarts

  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(urlPath, method)
  return response as RequestCartsData
}

export async function postMessageAsync(IRI: string, content: string): Promise<void> {
  const { method } = APIRoutes.PostMessage()

  await BasicAuthServiceHelper.requestAuthenticatedAsync(IRI, method, { content })
}

export async function replyMessageAsync(IRI: string, content: string): Promise<void> {
  const { method } = APIRoutes.ReplyMessage()

  await BasicAuthServiceHelper.requestAuthenticatedAsync(IRI, method, { content })
}

export async function reactMessageAsync(IRI: string, emoji: string): Promise<void> {
  const { method } = APIRoutes.ReactMessage()

  await BasicAuthServiceHelper.requestAuthenticatedAsync(IRI, method, { emoji })
}

export async function removeMessageAsync(IRI: string): Promise<void> {
  const { method } = APIRoutes.RemoveMessage()

  await BasicAuthServiceHelper.requestAuthenticatedAsync(IRI, method)
}

export async function hasPendingMissionAsync(): Promise<boolean> {
  const { path: urlPath, method } = APIRoutes.HasPendingMission

  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(urlPath, method)
  return (response as { hasPendingMission: boolean }).hasPendingMission as boolean
}
